import LegacyInterceptor from '../LegacyInterceptor'

const api = new LegacyInterceptor()

export default {
  getDadosCobranca(): any {
    return api.get(`/pessoas`)
  },

  updateDadosCobranca(data): any {
    return api.post(`/pessoas`, data)
  }
}
